import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-dynamic-menu-block], [xpoDynamicMenuBlock]',
  host: {
    class: 'xpo-DynamicMenu--block',
  },
})
export class XpoDynamicMenuBlockDirective {}
